import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage";

export const PublicRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/*" element={<Navigate replace to="/login" />} />
                <Route path="/login" element={<LoginPage page="login" />} />
                <Route path='/signup' element={<LoginPage page="signup" />} />
                <Route path='/forgot-password' element={<LoginPage page="forgot-password" />} />
                <Route path='/reset-password' element={<LoginPage page="reset-password" />} />
            </Routes>
        </>
    );
};                         
